import { BtvChannelCategoriesState } from './types';

export const initialState: BtvChannelCategoriesState = {
  btvChannelCategories: null,
  loadingBtvChannelCategories: false,
};
